<div class="park-days">
  <h4 class="park-days-title">Seleccionar Días</h4>
  <div class="park-days-options">
    <button type="button" *ngFor="let opt of dayOptions; trackBy: trackByKey" class="park-days-option"
            [class.active]="selectedOption?.key === opt.key" (click)="pick(opt)">
      <span class="park-days-circle"
            [style.background-color]="selectedOption?.key === opt.key ? buttonColorActive : null"
            [style.border-color]="buttonColorActive">{{ opt.label }}</span>
      <span class="park-days-sub">{{ opt.sub }}</span>
      <span class="park-days-variant" *ngIf="opt.variant" [title]="opt.variant">{{ opt.variant }}</span>
    </button>
  </div>

  <h4 class="park-days-title">Seleccionar Fecha</h4>
  <usb-park-calendar [from]="arrivalDate"
                     [to]="departureDate"
                     [price]="selectedOption?.price || 0"
                     [datePrices]="datePrices"
                     [selectedDate]="selectedDate"
                     [days]="selectedCount"
                     [sourceCurrency]="sourceCurrency"
                     [currencies]="currencies"
                     [currencyAgency]="currencyAgency"
                     [buttonColorActive]="buttonColorActive"
                     (dateChange)="dateChange.emit($event)">
  </usb-park-calendar>
  <p class="park-stay-note">
    <ng-container *ngIf="!addon">Elige el día de inicio entre {{ arrivalDate | date:'dd/MM/yyyy' }} y {{ departureDate | date:'dd/MM/yyyy' }}.</ng-container>
    <ng-container *ngIf="addon">Solo se pueden elegir los días con disponibilidad entre {{ arrivalDate | date:'dd/MM/yyyy' }} y {{ departureDate | date:'dd/MM/yyyy' }}; el precio puede variar según el día.</ng-container>
    <ng-container *ngIf="selectedOption">Tu ticket cubre {{ selectedOption.label }} {{ selectedOption.label === '1' ? 'día' : 'días' }} desde la fecha elegida.</ng-container>
  </p>
</div>
